import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=35efdfce&scoped=true"
import script from "./workList.vue?vue&type=script&lang=js"
export * from "./workList.vue?vue&type=script&lang=js"
import style0 from "./workList.vue?vue&type=style&index=0&id=35efdfce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35efdfce",
  null
  
)

export default component.exports